<template>
	<div class="card-form">
		
		<div class="card-list">
			<Card :card-fields="interact"
						:labels="formData"
						:isCardNumberMasked="isCardNumberMasked"
						:randomBackgrounds="randomBackgrounds"
						:backgroundImage="backgroundImage" />
		</div>
		<div class="card-form__inner">
			<div class="card-input">
				<label for="cardNumber" class="card-input__label">Card Number</label>
				<input type="tel"
							 :id="interact.cardNumber"
							 @input="changeNumber"
							 @focus="focusCardNumber"
							 @blur="blurCardNumber"
							 class="card-input__input"
							 :value="formData.cardNumber"
							 v-validate="'required'"
							 name="card number"
							 :maxlength="cardNumberMaxLength"
							 data-card-field
							 autocomplete="off" />
				<button type="button"
								class="card-input__eye"
								:class="{ '-active' : !isCardNumberMasked }"
								title="Show/Hide card number"
								tabindex="-1"
								:disabled="formData.cardNumber === ''"
								@click="toggleMask">
					reveal
				</button>
			</div>
			<div class="row">
				<div class="col-md-8">
					<div class="card-form__group w-100">
						<div class="card-input w-100">
							<label for="cardName" class="card-input__label">Name On Card</label>
							<div class="row">
								<div class="col-md-6 form-group">
									<input type="text"
												 :id="interact.firstname"
												 v-letter-only
												 @input="changeFirstName"
												 class="card-input__input w-100"
												 :value="formData.firstname"
												 v-validate="'required'"
												 placeholder="First"
												 name="first name on card"
												 data-card-field
												 autocomplete="off" />
								</div>
								<div class="col-md-6">
									<input type="text"
												 :id="interact.lastname"
												 v-letter-only
												 @input="changeLastName"
												 placeholder="Last"
												 class="card-input__input w-100"
												 :value="formData.lastname"
												 v-validate="'required'"
												 name="last name on card"
												 data-card-field
												 autocomplete="off" />
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="card-form__group">
						<div class="card-input w-100">
							<label for="cardZip" class="card-input__label">Zip</label>
							<input type="text"
										 :id="interact.cardZip"
										 @input="changeZip"
										 v-model="formData.cardZip"
										 class="card-input__input"
										 v-number-only
										 maxlength="5"
										 v-validate="'required'"
										 name="zip"
										 data-card-field
										 autocomplete="off" />
						</div>
					</div>
				</div>
			</div>
			<div class="card-form__row">
				<div class="card-form__col">
					<div class="card-form__group">
						<label for="cardMonth" class="card-input__label">Expiration Date</label>
						<select class="card-input__input -select"
										:id="interact.cardMonth"
										v-model="formData.cardMonth"
										v-validate="'required'"
										name="month"
										@change="changeMonth"
										data-card-field>
							<option value disabled selected>Month</option>
							<option v-bind:value="n < 10 ? '0' + n : n"
											v-for="n in 12"
											v-bind:disabled="n < minCardMonth"
											v-bind:key="n">
								{{generateMonthValue(n)}}
							</option>
						</select>
						<select class="card-input__input -select"
										:id="interact.cardYear"
										v-model="formData.cardYear"
										@change="changeYear"
										v-validate="'required'"
										name="year"
										data-card-field>
							<option value disabled selected>Year</option>
							<option v-bind:value="$index + minCardYear"
											v-for="(n, $index) in 12"
											v-bind:key="n">
								{{$index + minCardYear}}
							</option>
						</select>
					</div>
				</div>
				<div class="card-form__col -cvv">
					<div class="card-input">
						<label for="cardCvv" class="card-input__label">CVV</label>
						<input type="tel"
									 class="card-input__input"
									 v-number-only
									 :id="interact.cardCvv"
									 v-validate="'required'"
									 name="cvv"
									 maxlength="4"
									 :value="formData.cardCvv"
									 @input="changeCvv"
									 data-card-field
									 autocomplete="off" />
					</div>
				</div>
			</div>

			<button class="btn btn-primary btn-block btn-lg" @click.prevent="handleSubmit">Submit</button>

			<el-alert :title="serverError"
								type="error"
								:closable="false"
								class="mt-2 mb-2"
								v-if="serverError"
								effect="dark">
			</el-alert>

			<div class="form-check mt-2">
				
				<input type="checkbox" class="form-check-input" v-model="cbAgree" v-validate="'required'" data-vv-validate-on="change|click" name="agree" id="cbAgree">
				<label class="form-check-label" for="cbAgree" v-html="$parseHtml($store.state.terms)"></label>

			</div>

			<div v-if="errors.has('agree')" class="alert alert-danger">
				You must agree to the terms and conditions.
			</div>




		</div>
	</div>
</template>

<script>
	import Card from './Card'
	import amex from "@/components/icons/amex.vue";
	import diners from "@/components/icons/diners.vue";
	import mastercard from "@/components/icons/mastercard.vue";
	import visa from "@/components/icons/visa.vue";
	import discover from "@/components/icons/discover.vue";
	export default {
		name: 'CardForm',
		directives: {
			'number-only': {
				bind(el) {
					function checkValue(event) {
						event.target.value = event.target.value.replace(/[^0-9]/g, '')
						if (event.charCode >= 48 && event.charCode <= 57) {
							return true
						}
						event.preventDefault()
					}
					el.addEventListener('keypress', checkValue)
				}
			},
			'letter-only': {
				bind(el) {
					function checkValue(event) {
						if (event.charCode >= 48 && event.charCode <= 57) {
							event.preventDefault()
						}
						return true
					}
					el.addEventListener('keypress', checkValue)
				}
			}
		},
		props: {
			serverError: null,
			formData: {
				type: Object,
				default: () => {
					return {
						firstname: '',
						lastname: '',
						cardNumber: '',
						cardMonth: '',
						cardYear: '',
						cardCvv: '',
						cardZip: ''
					}
				}
			},
			backgroundImage: [String, Object],
			randomBackgrounds: {
				type: Boolean,
				default: true
			}
		},
		components: {
			Card,
			[amex.name]: amex,
			[diners.name]: diners,
			[mastercard.name]: mastercard,
			[visa.name]: visa,
			[discover.name]: discover
		},
		data() {
			return {
				cbAgree: false,
				interact: {
					cardNumber: 'v-card-number',
					firstname: 'v-card-firstname',
					lastname: 'v-card-lastname',
					cardMonth: 'v-card-month',
					cardYear: 'v-card-year',
					cardCvv: 'v-card-cvv',
					cardZip: 'v-card-zip'
				},
				minCardYear: new Date().getFullYear(),
				isCardNumberMasked: true,
				mainCardNumber: this.cardNumber,
				cardNumberMaxLength: 19
			}
		},
		computed: {
			minCardMonth() {
				if (this.formData.cardYear === this.minCardYear) return new Date().getMonth() + 1
				return 1
			}
		},
		watch: {
			'formData.cardYear': function() {
				if (this.formData.cardMonth < this.minCardMonth) {
					this.formData.cardMonth = ''
				}
			}
		},
		mounted() {
			this.maskCardNumber()
		},
		methods: {
			generateMonthValue(n) {
				return n < 10 ? `0${n}` : n
			},
			changeFirstName(e) {
				this.formData.firstname = e.target.value
				this.$emit('input-card-firstname', this.formData.firstname)
			},
			changeLastName(e) {
				this.formData.lastname = e.target.value
				this.$emit('input-card-lastname', this.formData.lastname)
			},
			changeNumber(e) {
				this.formData.cardNumber = e.target.value
				let value = this.formData.cardNumber.replace(/\D/g, '')
				// american express, 15 digits
				if ((/^3[47]\d{0,13}$/).test(value)) {
					this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
					this.cardNumberMaxLength = 17
				} else if ((/^3(?:0[0-5]|[68]\d)\d{0,11}$/).test(value)) { // diner's club, 14 digits
					this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ')
					this.cardNumberMaxLength = 16
				} else if ((/^\d{0,16}$/).test(value)) { // regular cc number, 16 digits
					this.formData.cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{4})/, '$1 $2 ').replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ')
					this.cardNumberMaxLength = 19
				}
				this.$emit('input-card-number', this.formData.cardNumber)
			},
			changeMonth() {
				this.$emit('input-card-month', this.formData.cardMonth)
			},
			changeYear() {
				this.$emit('input-card-year', this.formData.cardYear)
			},
			changeZip() {
				this.$emit('input-card-zip', this.formData.cardZip)
			},
			changeCvv(e) {
				this.formData.cardCvv = e.target.value
				this.$emit('input-card-cvv', this.formData.cardCvv)
			},
			handleSubmit() {



				this.$validator.validateAll().then(valid => {
					if (!valid) {
						this.$message.error("All fields are required");
					} else {

						//if (this.cardType)
						let cardNo = this.formData.cardNumberReal;
						var s = 0;
						var doubleDigit = false;
						for (var i = cardNo.length - 1; i >= 0; i--) {
							var digit = +cardNo[i];
							if (doubleDigit) {
								digit *= 2;
								if (digit > 9)
									digit -= 9;
							}
							s += digit;
							doubleDigit = !doubleDigit;
						}
						if (s % 10 == 0) {
							this.$emit("valid");
						} else {
							this.$emit("invalid", "Your card is invalid");
							//this.$message.error('Your card is invalid.');
						}

					}
				});

			},
			blurCardNumber() {
				if (this.isCardNumberMasked) {
					this.maskCardNumber()
				}
			},
			maskCardNumber() {
				this.mainCardNumber = this.formData.cardNumber
				this.formData.cardNumberReal = this.mainCardNumber.replace(/\s/g, '');
				let arr = this.formData.cardNumber.split('')
				arr.forEach((element, index) => {
					if (index > 4 && index < 14 && element.trim() !== '') {
						arr[index] = '*'
					}
				})
				this.formData.cardNumber = arr.join('')
			},
			unMaskCardNumber() {
				this.formData.cardNumber = this.mainCardNumber
			},
			focusCardNumber() {
				this.unMaskCardNumber()
			},
			toggleMask() {
				this.isCardNumberMasked = !this.isCardNumberMasked
				if (this.isCardNumberMasked) {
					this.maskCardNumber()
				} else {
					this.unMaskCardNumber()
				}
			}
		}
	}
</script>

<style lang="scss">
	@import "../assets/style.scss";
</style>